import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import Header from "./Header";
import AdminHeader from "./adminPages/AdminHeader";
import AdminFooter from "./adminPages/AdminFooter";
import Footer from "./Footer";
import AdminSideMenu from "./adminPages/AdminSideMenu";

const RootDiv = styled("div")({
  backgroundColor: "#F5F5F5",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  //  flex: "1 1 auto",
  overflow: "auto",
  minHeight: "100vh",
  minWidth: "1790px", //1500 IE-111 SP
  overflowX: "auto",
});

const SideMenuWrapperDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  minWidth: "1400px",
  marginTop: 50,
  paddingLeft: 0,
  marginBottom: 0,
  paddingBottom: 0,
});

const admin_string = process.env.REACT_APP_ADMIN_URL || "/t31u4YYky50K";

const Layout = ({ children }) => {
  const location = useLocation();
  const [isAdminPanel, setIsAdminPanel] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  /// detect admin panel and authentication
  useEffect(() => {
    if (location.pathname.includes(admin_string)) {
      setIsAdminPanel(true);
    } else {
      setIsAdminPanel(false);
    }

    if (location.pathname.includes("signin")) {
      setIsAuthenticated(false);
    } else {
      setIsAuthenticated(true);
    }
  }, [location]);

  useEffect(() => {
    if (isAdminPanel) {
      document.body.style.overflowX = "auto !important";
      document.body.style.overflowY = "hidden";
    }
  }, []);

  return (
    <>
      {isAdminPanel && (
        <RootDiv>
          <AdminHeader />
          {isAuthenticated && (
            <>
              <SideMenuWrapperDiv>
                <AdminSideMenu />
                {children}
              </SideMenuWrapperDiv>
              <AdminFooter />
            </>
          )}
          {!isAuthenticated && (
            <>
              {children}
              <AdminFooter />
            </>
          )}
        </RootDiv>
      )}
      {!isAdminPanel && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Header />
          <Box sx={{ flex: 1 }}>{children}</Box>
          <Footer />
        </Box>
      )}
    </>
  );
};

export default Layout;
